// extracted by mini-css-extract-plugin
module.exports = {"web_about":"web_about--1aROg","title":"title--LnbxP","about_text":"about_text--1hgkU","align_bth_wrapper":"align_bth_wrapper--3Usst","align_btn":"align_btn--iD5wX"};